import React, { Component } from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { fetchSettings } from "TicketAction";
import { contentContainerWidth } from "Constants";
import LiveQA from "LiveQA";
import PollList from "PollList";
import Rating from "Rating";
import PollMenu from "./components/common/poll-menu";

class Polls extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchSettings(this.props.session);
  }

  renderOptionList() {
    return this.props.pollMenus.map((item, index) => {
      if (item) {
        return <PollMenu key={item.iconName} item={item} />;
      }
    });
  }

  render() {
    return (
      <div>
        <div className="content-parent-container">
          <div className="content-submenu vertical-line">
            <div>
              <ul className="list-group">{this.renderOptionList()}</ul>
            </div>
          </div>
          <div
            className="content-subcontainer"
            // style={{ width: `${contentContainerWidth}px` }}
          >
            <Route
              path="/dashboard/polls/liveqa"
              history={this.props.history}
              component={LiveQA}
            />
            <Route
              path="/dashboard/polls/poll"
              history={this.props.history}
              component={PollList}
            />
            <Route
              path="/dashboard/polls/rating"
              history={this.props.history}
              component={Rating}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    pollMenus: state.pollMenus,
  };
}

export default connect(mapStateToProps, { fetchSettings })(Polls);
